import styled from 'styled-components'

const StyledIgnoredDishTypeModalContainer = styled.div`
  display: flex;
`

export default StyledIgnoredDishTypeModalContainer
